import { render, staticRenderFns } from "./recommendSwiper.vue?vue&type=template&id=4ecea74b&scoped=true"
import script from "./recommendSwiper.vue?vue&type=script&lang=js"
export * from "./recommendSwiper.vue?vue&type=script&lang=js"
import style0 from "./recommendSwiper.vue?vue&type=style&index=0&id=4ecea74b&prod&lang=scss"
import style1 from "./recommendSwiper.vue?vue&type=style&index=1&id=4ecea74b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecea74b",
  null
  
)

export default component.exports